import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
export default function MainHeading({
  heading,
  width = "100%",
  mobileWidth,
}: {
  heading: string;
  width?: string;
  mobileWidth?: string;
}) {
  return (
    <>
      <Typography
        variant="subtitle1"
        sx={{
          textTransform: "uppercase",
          textAlign: "center",
          fontSize: { sm: "1.5rem", xs: "1rem" },
        }}
      >
        {heading}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <Divider
          variant="middle"
          sx={{
            margin: "0.5rem 0rem 1rem 0rem",
            width: { xs: mobileWidth || width, sm: width },
            border: 0,
            height: "1px",
          }}
        />
      </Box>
    </>
  );
}
